import { useCallback, useState } from "react";

import { NewUser } from "@/api/endpoints/organization";
import { User } from "@/types/User";
import Wizard from "@components/Wizard";

import InviteContext from "./InviteContext";
import Invite from "./steps/Invite";
import Receipt from "./steps/Receipt";
import SetReportSubscriptions from "./steps/SetReportSubscriptions";
import SetSearchSubscriptions from "./steps/SetSearchSubscriptions";

const STEPS = [Invite, SetSearchSubscriptions, SetReportSubscriptions, Receipt];

export type InviteWizardProps = {
  organizationUuid: string;
  userDefaults: Partial<NewUser>;
};

const InviteWizard: React.FunctionComponent<InviteWizardProps> = ({
  organizationUuid,
  userDefaults,
}) => {
  const [user, setUser] = useState<Nullable<User>>(null);

  const reset = useCallback(() => {
    setUser(null);
  }, []);

  return (
    <InviteContext.Provider
      value={{
        userDefaults,
        organizationUuid,
        user,
        setUser,
        reset,
      }}
    >
      <Wizard steps={STEPS} />
    </InviteContext.Provider>
  );
};
export default InviteWizard;
